import script from "./Wine.vue?vue&type=script&setup=true&lang=js"
export * from "./Wine.vue?vue&type=script&setup=true&lang=js"

import "./Wine.vue?vue&type=style&index=0&id=2d001ce8&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d001ce8"]])

export default __exports__